module.exports = __webpack_public_path__ + "static/media/icono-videos.f75c4568.jpg";